// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3oDtg","item":"PaymentsMobile_item__23zjD","label":"PaymentsMobile_label__AMZbX","amount":"PaymentsMobile_amount__3SVsg"};